import { Box, Link } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import RatingQuestion from "./RatingQuestion";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
  questionsWrapper: {
    marginBottom: theme.spacing(2)
  },
  linkWrapper: {
    "& a": {
      marginRight: "2em",
      cursor: "pointer"
    }
  }
}));

const RatingQuestionsList = ({ ratingQuestions, openKingsleyPortalClick }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <Box>
      <Box
        className={classes.questionsWrapper}
        display="flex"
        justifyContent="center"
        flexWrap="wrap"
      >
        {ratingQuestions.map(question => (
          <Box mx={1} mb={2}>
            <RatingQuestion key={question.id} question={question} />
          </Box>
        ))}
      </Box>
      <Box
        display="flex"
        justifyContent="flex-end"
        className={classes.linkWrapper}
      >
        <Link
          onClick={openKingsleyPortalClick}
          variant="button"
          color="primary"
        >
          {t("kingsleyWidget.linkTitle")}
        </Link>
      </Box>
    </Box>
  );
};

export default RatingQuestionsList;

RatingQuestionsList.propTypes = {
  ratingQuestions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      score: PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
      }),
      breakout: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          value: PropTypes.string
        })
      )
    })
  ),
  openKingsleyPortalClick: PropTypes.func
};
